import isNil from 'lodash-es/isNil'

import { EMPTY_STRING } from '../../../constants/common'

import {
  getFormFieldSelectLabel,
  getFormFieldSelectValue,
} from './FormFieldSelect.utils'

import * as styles from './FormFieldSelect.module.css'

function FormFieldSelect({
  Select,
  className = styles.FormFieldSelect,
  getLabel = getFormFieldSelectLabel,
  getValue = getFormFieldSelectValue,
  inputHeight = 40,
  multi,
  value,
  onChange,
  onClear,
  ...restProps
}) {
  const activeItems = multi
    ? value?.map(i => getValue(i))
    : [...(!isNil(getValue(value)) ? [getValue(value)] : [])]

  function handleChange(nextValue) {
    if (multi || getValue(value) !== getValue(nextValue)) {
      onChange(nextValue)
    }
  }

  return (
    <Select
      {...restProps}
      activeItems={activeItems}
      className={className}
      getLabel={getLabel}
      getValue={getValue}
      inputHeight={inputHeight}
      inputValue={value ? getLabel?.(value) : EMPTY_STRING}
      isMulti={multi}
      value={value}
      onClearInput={onClear}
      onClick={handleChange}
    />
  )
}

export default FormFieldSelect
